import cloneDeep from "lodash.clonedeep";
import {FC, useEffect, useState} from "react"
import {useParams} from "react-router-dom";
import useWhoIs from "../../hooks/useWhoIs";
import {useChangePasswordMutation, useSubmitDataMutation} from "../../services/goroskop"
import {useSnackbar} from "notistack";
import ScrollDialog from "../quiz/Dialog";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";

import FormUser from "./constituents/formUser";
import DraggableEnhancedTable from "../admin/constituents/dragableTable";
import EnhancedTable from "../admin/constituents/Table";

const UserProfile: FC = () => {
  let {user_id} = useParams()
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmation: '',
  });
  const [passwordError, setPasswordError] = useState('');
  const {enqueueSnackbar} = useSnackbar();

  const [submitData, {data, error, isLoading}] = useSubmitDataMutation()
  const [favSubData, favData] = useSubmitDataMutation();
  const [changePassword, {isLoading: isChangingPassword}] = useChangePasswordMutation();

  let deepCloneData = (favData.data && typeof favData.data !== 'string') ? cloneDeep(favData.data) : []

  const account = useWhoIs().Account

  const newData = (favData.data && typeof favData.data !== 'string' && data && typeof data !== 'string' && deepCloneData.length) ?
    (favData.data.find(el => el.id === data[0].id)
      ? (deepCloneData.splice(0, 0, deepCloneData.splice(Number(deepCloneData.findIndex(el => el.id === data[0].id)), 1)[0]) && deepCloneData)
      : data.slice().concat(deepCloneData)) : []


  let FormDefaultValues = data ? (typeof data[0] != 'string' ? data[0] : false) : false

  useEffect(() => {
    let fd = new FormData()
    fd.append('user_id', user_id ? user_id : '')

    submitData({name: 'profile.php', data: fd})

  }, [user_id])

  const closePasswordDialog = () => {
    if (isChangingPassword) return;

    setIsPasswordDialogOpen(false);
    setPasswordError('');
    setPasswordForm({currentPassword: '', newPassword: '', confirmation: ''});
  };

  const submitPasswordChange = async () => {
    const {currentPassword, newPassword, confirmation} = passwordForm;

    if (!currentPassword || !newPassword || !confirmation) {
      setPasswordError('Заполните все поля');
      return;
    }

    if (newPassword.length < 6) {
      setPasswordError('Новый пароль должен содержать не менее 6 символов');
      return;
    }

    if (newPassword !== confirmation) {
      setPasswordError('Новые пароли не совпадают');
      return;
    }

    setPasswordError('');
    const formData = new FormData();
    formData.append('current_password', currentPassword);
    formData.append('new_password', newPassword);

    try {
      const response = await changePassword(formData).unwrap();

      if (!response.status) {
        setPasswordError(response.msg || 'Не удалось изменить пароль');
        return;
      }

      enqueueSnackbar(response.msg || 'Пароль изменён', {variant: 'success'});
      closePasswordDialog();
    } catch {
      setPasswordError('Не удалось изменить пароль. Попробуйте ещё раз');
    }
  };

  /*useEffect(() => {
      let fd = new FormData()
      //fd.append('fav', typeof FormDefaultValues !== 'boolean' ? FormDefaultValues.fav : '')
      fd.append('fav', user_id ? user_id : '')

      favSubData({ name: 'cabinet/get_favorites.php', data: fd })

  }, [FormDefaultValues])*/


  return (
    <>
      {error && <h1>oops, error: {JSON.stringify(error)}</h1>}
      {isLoading && <h1>Загрузка... </h1>}
      {FormDefaultValues && (
        <FormUser
          defaultValues={FormDefaultValues}
          onChangePassword={() => {
            setPasswordError('');
            setIsPasswordDialogOpen(true);
          }}
        />
      )}
      <Dialog
        fullWidth
        maxWidth="xs"
        open={isPasswordDialogOpen}
        onClose={closePasswordDialog}
      >
        <DialogTitle>Сменить пароль</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{marginTop: 1}}>
            <TextField
              autoComplete="current-password"
              error={Boolean(passwordError)}
              fullWidth
              label="Текущий пароль"
              name="current-password"
              onChange={(event) => setPasswordForm((form) => ({...form, currentPassword: event.target.value}))}
              type="password"
              value={passwordForm.currentPassword}
            />
            <TextField
              autoComplete="new-password"
              fullWidth
              label="Новый пароль"
              name="new-password"
              onChange={(event) => setPasswordForm((form) => ({...form, newPassword: event.target.value}))}
              type="password"
              value={passwordForm.newPassword}
            />
            <TextField
              autoComplete="new-password"
              error={Boolean(passwordError)}
              fullWidth
              label="Повторите новый пароль"
              name="new-password-confirmation"
              onChange={(event) => setPasswordForm((form) => ({...form, confirmation: event.target.value}))}
              type="password"
              helperText={passwordError || 'Не менее 6 символов'}
              value={passwordForm.confirmation}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={isChangingPassword} onClick={closePasswordDialog}>
            Закрыть
          </Button>
          <Button disabled={isChangingPassword} onClick={submitPasswordChange} variant="contained">
            Сменить пароль
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default UserProfile
